// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import "./icons"; // icon
import nicescroll from "jquery.nicescroll";

// vuex
import store from "./store";

// 路由
import router from "./router";
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  document.title = store.state.title;
  next();
});

// ElementUI插件
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);


import waterfall from "vue-waterfall2";
Vue.use(waterfall);

//element动画效果
// fade/zoom 等
import "element-ui/lib/theme-chalk/base.css";
// collapse 展开折叠
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";
Vue.component(CollapseTransition.name, CollapseTransition);

// echarts图表插件
import echarts from "echarts";
Vue.prototype.$echarts = echarts;

// 滚动条
import vuescroll from "vuescroll";
Vue.use(vuescroll, {
  ops: {
    vuescroll: {},
    scrollPanel: {},
    rail: {},
    bar: {
      onlyShowBarOnScroll: false, // 是否只在滚动时显示 bar
      background: "#08961f", // 滚动条颜色
      keepShow: true, // 是否一直显示
      size: "5px" // 滚动条宽度
    }
  } // 滚动条全局配置
});

// 奥森字体图标
//import 'font-awesome/css/font-awesome.css';

// swiper轮播图插件
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
Vue.use(VueAwesomeSwiper);

Vue.config.productionTip = false;

// Axios调用接口并设置拦截器
import Axios from "axios";
import Qs from "qs";
Vue.prototype.axios = Axios;
Vue.prototype.Qs = Qs;

// 加载层
import { showLoading, hideLoading } from "../static/js/loading";

Axios.interceptors.request.use(
  function(config) {
    // 调用接口时显示loading

    if (
      config.url ==
        "http://47.110.245.84:9010/zhsd/wetland/impression/findAnimalFilter" ||
      config.url ==
        "http://47.110.245.84:9010/zhsd/wetland/impression/findPlantFilter"
    ) {
    } else {
      showLoading();
    }
    // 在发送请求之前做些什么
    if (config.method === "post") {
      config.data = Qs.stringify(config.data);
    }
    // 请求头加token
    if (store.state.token || sessionStorage.getItem("token")) {
      config.headers["token"] =
        store.state.token || sessionStorage.getItem("token");
    }
    return config;
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
Axios.interceptors.response.use(
  function(response) {
    console.log(response)
    // 对响应数据做点什么
    if(response.headers.token){
      sessionStorage.setItem("token",response.headers.token)
      console.log(1111)
      console.log( response.headers.token)
    }
    response = JSON.stringify(response);
    response = response.replace(/ByDansin/g, "1002979996@qq.com");
    response = JSON.parse(response);
    // 接口返回数据后隐藏loading
    hideLoading();
    return response;
  },
  function(error) {
    // 对响应错误做点什么
    setTimeout(() => {
      Vue.prototype.$message({
        message: "请求失败！",
        type: "error"
      });
      hideLoading();
    }, 3000);
    return Promise.reject(error);
  }
);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  store,
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js